import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectVideo20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectVideo20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5H10a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1M1 4.5A2.5 2.5 0 0 1 3.5 2H10a2.5 2.5 0 0 1 2.5 2.5v11A2.5 2.5 0 0 1 10 18H3.5A2.5 2.5 0 0 1 1 15.5zm14 1A.75.75 0 0 0 15 7h3.238a.75.75 0 0 0 0-1.5zm-.75 4.25A.75.75 0 0 1 15 9h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m-4.578 1.055a1 1 0 0 0 0-1.61L5.593 6.19A1 1 0 0 0 4 6.995v6.01a1 1 0 0 0 1.593.805zM5.5 7.985 8.236 10 5.5 12.016z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectVideo20);
